import * as types from 'store/mutation-types'
import authConst from './authConst'

export default {
  [types.SET_LOGIN] (state, token) {
    state.token = token
    state.isLogged = true
  },
  [types.REMOVE_LOGIN] (state) {
    state.token = null
    state.isLogged = false
    state.user = null
  },
  [types.SET_USER] (state, user) {
    state.user = user
  },
  [types.SET_CURRENT_PRODUCT] (state, productId) {
    state.currentProduct = productId
    window.localStorage.removeItem(authConst.productKey)
    window.localStorage.setItem(authConst.productKey, productId)
  },
  [types.SET_CURRENT_PRODUCT_DATA] (state, productData) {
    state.currentProductData = productData
    window.localStorage.removeItem(authConst.productDataKey)
    window.localStorage.setItem(authConst.productDataKey, JSON.stringify(productData))
  },
  [types.REMOVE_CURRENT_PRODUCT] (state) {
    state.currentProduct = null
    state.currentProductData = {}
    window.localStorage.removeItem(authConst.productKey)
    window.localStorage.removeItem(authConst.productDataKey)
  },
  [types.SET_USER_PHOTO_URL] (state, newPhoto) {
    state.userPhotoUrl = newPhoto
  }
}
